import CWImage from '@/context/global/components/g00/g00-d00-g003-cw-image-fallback';
import IconPlay from '@/context/global/components/Icon/IconPlay';
import { TSong } from '@/context/global/types/song';

type CurrentSongProps = {
  song?: TSong | null;
  isPlaying: boolean;
  onTogglePlay?: () => void;
};

const CurrentSong = ({ song, isPlaying, onTogglePlay }: CurrentSongProps) => {
  if (!song) return null;

  return (
    <div className="rounded-[10px] bg-ais-green/10 p-4 pl-[52px]">
      <div className="flex items-center gap-3">
        <div className="relative h-16 w-16 shrink-0 overflow-hidden rounded-lg">
          <CWImage
            fill
            src={song.coverUrl ?? ''}
            alt={song.title ?? ''}
            className="object-cover"
          />
          <button
            onClick={onTogglePlay}
            className="absolute inset-0 flex transform cursor-pointer items-center justify-center transition-all hover:scale-110"
            aria-label={isPlaying ? 'Pause' : 'Play'}
          >
            <IconPlay className="text-ais-green" size={32} />
          </button>
        </div>

        <div className="min-w-0 flex-1">
          <h3 className="truncate text-xl font-bold text-white md:text-2xl">
            {song.title}
          </h3>
          <p className="truncate text-lg font-medium text-gray-400 md:text-xl">
            {song.artist}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CurrentSong;
